<template>
  <section
    class="entry-sider"
    ref="entrtSider"
    :class="{
      'entry-sider--active': visible,
      'entry-sider--unfold': unfold
    }"
  >
    <div class="entry-sider__content">
      <!-- 左侧菜单 -->
      <div class="entry-sider-panel">
        <section
          class="entry-sider-panel__hd"
          @mouseenter="allAppMouseEnter"
          @mouseout="allAppMouseOut"
        >
          <a class="entry-sider__menu" @click="handleSiderPaneToggle">
            <div class="entry-sider__menu__hd">
              <a-icon :type="!unfold ? 'menu-fold' : 'menu-unfold'" />
            </div>
            <div class="entry-sider__menu__bd">{{ i18nRender('layouts.allapplication') }}</div>
          </a>
        </section>

        <!-- 系统自定义菜单 -->
        <section class="entry-sider-panel__bd">
          <div class="entry-slider-tabs" @scroll="handleScroll">
            <template v-for="menu in menus">
              <entry-sider-item
                :key="menu.key"
                :menu="menu"
                :visible="visible || unfold"
                :currentLang="currentLang"
                :scrollTop="scrollTop"
                :activeKey="(menusInfo && menusInfo.key) || ''"
                @mousemove="handleMenusMousemove"
                @mouseout="handleClearTimeout"
                @click="handleMenusClick"
                @menuchange="handleMenuChange"
                @pushpin="handlePushpin"
              >
                <div class="entry-sider__menu__arrow-down" v-if="menu.childMenus.filter(item => item.pushpin).length"></div>
                <div class="entry-sider__menu__arrow-right" v-else></div>
              </entry-sider-item>
            </template>
          </div>
        </section>

        <!-- 自定义场景菜单- 隐藏 -->
        <section class="entry-sider-panel__ft">
          <div class="entry-slider-tabs">
            <entry-sider-item
              :menu="{ icon: 'thunderbolt', tab: i18nRender('layouts.commonmenu') }"
              :visible="visible"
              @click="handleMenusChange('__HISTORY__')"
            />
            <!-- 添加自定义场景 -->
            <!-- <entry-sider-item :menu="{ icon: 'plus-circle', tab: i18nRender('layouts.customscene') }" :visible="visible" click="handleAdd" /> -->
          </div>
        </section>
      </div>

      <!-- 菜单详情界面 -->
      <div class="entry-sider-info" v-if="menusInfo">
        <section class="entry-sider-info__hd">
          <icon-font class="entry-sider-info__close" type="gb-icon-guanbi" @click="close" />
          <a-input-search
            v-model="keyword"
            size="large"
            :placeholder="i18nRender('layouts.search.placeholder')"
            style="width:75%;"
          />
          <div class="entry-sider-info__histroy">
            <div class="entry-sider-info__histroy__label">{{ i18nRender('layouts.history') }}：</div>
            <div class="entry-sider-info__histroy__value" v-if="panesHistory.length">
              <a
                v-for="pane in panesHistory"
                :key="pane.key"
                class="entry-sider-info__histroy__item"
                href="javascript:;"
                @click="(key) => handleMenuChange(pane.key, { statisticsType: 3, searchKey: '' })"
              >{{ pane | menuLocalName }}</a>
            </div>
            <div class="entry-sider-info__histroy__value" v-else>
              <span style="color:#999;">{{ i18nRender('layouts.text.undefined') }}</span>
            </div>
          </div>
        </section>
        <section class="entry-sider-info__bd" v-if="keyword">
          <entry-menus-search
            :menus="menus"
            :keyword="keyword"
            :currentLang="currentLang"
            @click="(key) => handleMenuChange(key, { statisticsType: 1, searchKey: keyword })"
          />
        </section>
        <section class="entry-sider-info__bd" v-else>
          <entry-menus-item
            tap-position="top"
            :menu="menusInfo"
            :currentLang="currentLang"
            @click="(key) => handleMenuChange(key, { statisticsType: 2, searchKey: '' })"
            @pushpin="handlePushpin"
          />
        </section>
      </div>
    </div>

    <!-- 背景蒙版 -->
    <div
      class="entry-sider__mask"
      :class="{'entry-sider__mask--active': visible}"
      @mouseover="close"
    />
  </section>
</template>

<script>
import EntryMenusItem from './EntryMenusItem'
import EntryMenusSearch from './EntryMenusSearch'
import EntrySiderItem from './EntrySiderItem'
import { i18nRender } from '@/locales'
export default {
  name: 'EntrySider',
  components: {
    EntryMenusSearch,
    EntryMenusItem,
    EntrySiderItem
  },
  props: {
    menus: {
      type: Array,
      default () {
        return []
      }
    },
    menusActiveID: {
      type: String,
      default: ''
    },
    panesHistory: {
      type: Array,
      default: () => []
    },
    currentLang: {
      type: String,
      default: 'zh_CN'
    },
    unfold: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      timer: null,
      visible: false,
      menusInfo: null,
      keyword: '',
      scrollTop: 0
    }
  },
  methods: {
    i18nRender,
    show () {
      this.visible = true
    },
    close () {
      this.visible = false
      this.menusInfo = null
    },
    clear () {
      this.menusInfo = null
    },
    handleSiderPaneToggle () {
      const unfold = !this.unfold
      const cssText = `width: ${unfold ? '160' : '48'}px`
      this.$refs['entrtSider'].style.cssText = cssText
      document.querySelector('.entry-sider-panel').style.cssText = cssText
      this.$store.commit('entry/SET_UNFOLD', unfold)
    },
    allAppMouseEnter (e) {
      if (this.visible) return

      if (!this.unfold) {
        this.$refs['entrtSider'].style.cssText = 'width: 48px; overflow:hidden'
        document.querySelector('.entry-sider-panel').style.cssText = 'width: 48px'
      }
      document.querySelector('.entry-sider__mask').style.cssText = 'display:none'
    },
    allAppMouseOut (e) {
      this.$refs['entrtSider'].style.cssText = ''
      document.querySelector('.entry-sider-panel').style.cssText = ''
      document.querySelector('.entry-sider__mask').style.cssText = ''
    },
    handleClearTimeout () {
      clearTimeout(this.timer)
      this.timer = null
    },
    handleMenusClick (menu) {
      this.visible = !this.visible
    },
    handleMenusMousemove (menu) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.menusInfo = menu
        }, 100)
      }
    },
    handleMenusChange (key) {
      this.$emit('menuschange', key)
    },
    /**
     *  切换子菜单
     * @param[key] String - menuId
     * @param[record] Objecgt - { statisticsType, searchKey }
     */
    handleMenuChange (key, record = {}) {
      this.$emit('menuchange', key, record)
      this.close()
    },
    handleError () {
      this.$message.warning('功能尚未开通，拼命开发中...')
    },
    handleAdd () {
      this.$emit('menusadd')
    },
    handlePushpin (e) {
      this.$emit('menupushpin', e)
    },
    handleScroll (e) {
      const { scrollTop } = e.target
      this.scrollTop = scrollTop
    }
  }
}
</script>

<style lang="less">
  .entry-sider {
    position: relative;
    width: 48px;
  }

  .entry-sider--active {
    .entry-sider-info {
      position: relative;
      left: 0;
      opacity: 1;
      transition: opacity .5s, left .3s;
    }
  }
  // 左侧菜单设置为展开的样式
  .entry-sider--unfold {
    width: 160px;
    .entry-sider-panel {
      width: 160px;
      transition: width .2s;
      .entry-sider__menu__bd,
      .entry-sider__menu__arrow-right,
      .entry-sider__menu__arrow-down {
        display: block;
      }
    }
  }

  .entry-sider__content {
    display: flex;
    height: 100%;
    position: absolute;
    z-index: 901;

    &:hover {
      .entry-sider-panel {
        width: 160px;
        transition: width .2s;
      }

      .entry-sider__menu__bd,
      .entry-sider__menu__arrow-right,
      .entry-sider__menu__arrow-down,
      .entry-slider-tab > .entry-sider__menu-children {
        display: block;
      }
    }
  }

  .entry-sider-panel {
    display: flex;
    flex-direction: column;
    width: 48px;
    height: 100%;
    background: #ffffff;
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    position: relative;
    z-index: 10;
    transition: .3s;
  }
  .entry-sider-panel__hd {
    position: relative;

    &::after {
      content: " ";
      height: 1px;
      border-top: 1px solid #e8e8e8;
      position: absolute;
      right: 5px;
      bottom: 0;
      left: 5px
    }
    .entry-sider__menu {
      height: 36px;
      font-size: 14px;
    }

    .anticon {
      font-size: 16px;
    }
  }
  .entry-sider-panel__bd {
    flex: 1;
    padding: 8px 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    &:hover {
      width: 160px;
    }
  }
  .entry-sider-panel__ft {
    padding: 8px 0;
    border-top: 1px solid #e8e8e8;
  }

  .entry-slider-tabs {
    width: calc(100% + 17px);
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-color: transparent transparent;
    scrollbar-track-color: transparent;
    -ms-scrollbar-track-color: transparent;

    &::-webkit-scrollbar {
      cursor: pointer;
      width: 17px;
      height: 0px;
      background-color: #fff;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0,0,0,.3);
      background-color: rgba(0,0,0,.3);
      -webkit-border-radius: 6px;
      -moz-border-radius: 6px;
      border-radius: 6px;
    }

    &::-webkit-scrollbar-track {
      background-color: #fff;
    }
  }

  .entry-sider__menu {
    padding: 4px 12px;
    display: flex;
    width: 100%;
    height: 32px;
    font-size: 12px;
    line-height: 24px;
    align-items: center;
    position: relative;
    cursor: default;

    .anticon {
      vertical-align: -1px;
    }

    .ant-avatar {
      width: 14px;
      height: 14px;
      background-color: transparent;
      color: inherit;
      font-size: inherit;
      line-height: 14px;

      &.ant-avatar-icon {
        font-size: inherit;
      }
    }
  }
  .entry-sider__menu__hd {
    margin-right: 5px;
    flex-shrink: 0;
    width: 24px;
    text-align: center;
    line-height: 0;
    position: relative;
  }
  .entry-sider__menu__bd {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    position: relative;
    display: none;
  }
  .entry-sider__menu__arrow-right {
    padding-right: 22px;
    position: relative;
    display: none;

    &::after {
      content: " ";
      width: 8px;
      height: 24px;
      -webkit-mask-position: center;
      mask-position: center;
      -webkit-mask-repeat: no-repeat;
      mask-repeat: no-repeat;
      -webkit-mask-size: 100%;
      mask-size: 100%;
      background-color: currentColor;
      color: inherit;
      -webkit-mask-image: url(data:image/svg+xml,%3Csvg%20width%3D%2212%22%20height%3D%2224%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M2.454%206.58l1.06-1.06%205.78%205.779a.996.996%200%20010%201.413l-5.78%205.779-1.06-1.061%205.425-5.425-5.425-5.424z%22%20fill%3D%22%23B2B2B2%22%20fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E);
      mask-image: url(data:image/svg+xml,%3Csvg%20width%3D%2212%22%20height%3D%2224%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M2.454%206.58l1.06-1.06%205.78%205.779a.996.996%200%20010%201.413l-5.78%205.779-1.06-1.061%205.425-5.425-5.425-5.424z%22%20fill%3D%22%23B2B2B2%22%20fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E);
      position: absolute;
      top: 50%;
      right: 8px;
      margin-top: -12px;
    }
  }
  .entry-sider__menu__arrow-down {
    padding-right: 22px;
    position: relative;
    display: none;
    transform: rotate(90deg);

    &::after {
      content: " ";
      width: 8px;
      height: 24px;
      -webkit-mask-position: center;
      mask-position: center;
      -webkit-mask-repeat: no-repeat;
      mask-repeat: no-repeat;
      -webkit-mask-size: 100%;
      mask-size: 100%;
      background-color: currentColor;
      color: inherit;
      -webkit-mask-image: url(data:image/svg+xml,%3Csvg%20width%3D%2212%22%20height%3D%2224%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M2.454%206.58l1.06-1.06%205.78%205.779a.996.996%200%20010%201.413l-5.78%205.779-1.06-1.061%205.425-5.425-5.425-5.424z%22%20fill%3D%22%23B2B2B2%22%20fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E);
      mask-image: url(data:image/svg+xml,%3Csvg%20width%3D%2212%22%20height%3D%2224%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M2.454%206.58l1.06-1.06%205.78%205.779a.996.996%200%20010%201.413l-5.78%205.779-1.06-1.061%205.425-5.425-5.425-5.424z%22%20fill%3D%22%23B2B2B2%22%20fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E);
      position: absolute;
      top: 50%;
      right: 8px;
      margin-top: -12px;
    }
  }
  .entry-sider__menu__ft {
    padding-right: 3px;
  }
  a.entry-sider__menu {
    color: inherit;
    transition-duration: 0s;
    cursor: pointer;
  }
  a.entry-sider__menu:hover {
    background: #F6F7FA;
    color: #333;
  }

  .entry-sider-info {
    display: flex;
    flex-direction: column;
    width: 900px;
    height: 100%;
    background: #ffffff;

    position: absolute;
    left: -840px;
    opacity: 0;
  }
  .entry-sider-info__hd {
    padding: 16px 22px 0;
    position: relative;
  }
  .entry-sider-info__bd {
    flex: 1;
    min-height: 0;

    .ant-empty {
      margin-top: 35%;
    }

    .ant-empty-description {
      margin-top: 15px;
      font-size: 16px;
      color: #999999;
    }

    > .entry-menus-tabs {
      margin: 10px 0 0;
      box-shadow: none;
    }

    > .entry-menus-content {
      margin: 0;
      box-shadow: none;
      max-height: 100%;
    }

    .entry-menus-tabs-content {
      width: 100%;
    }
  }
  .entry-sider-info__close {
    font-size: 24px;
    position: absolute;
    top: 25px;
    right: 22px;
    cursor: pointer;
  }
  .entry-sider-info__histroy {
    margin-top: 16px;
    color: #333;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
  }
  .entry-sider-info__histroy__label {
    float: left;
    color: #666666;
  }
  .entry-sider-info__histroy__value {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .entry-sider-info__histroy__item {
    margin: 0 5px;
  }
  a.entry-sider-info__histroy__item {
    color: initial;
  }

  .entry-sider__mask {
    display: none;
    background: rgba(0,0,0,.45);
    position: fixed;
    z-index: 900;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .entry-sider__mask--active {
    display: block;
  }
</style>
